import { useEffect, useState, useCallback } from "react";

const EnrollContext = {
  open: () => {},
};

export function useEnroll() {
  const [open, setOpen] = useState(false);

  const trigger = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    EnrollContext.open = trigger;
    const seen = sessionStorage.getItem("sb_enroll_auto");
    if (!seen) {
      const t = setTimeout(() => {
        setOpen(true);
        sessionStorage.setItem("sb_enroll_auto", "1");
      }, 9000);
      return () => clearTimeout(t);
    }
  }, [trigger]);

  return { open, setOpen, trigger, close };
}

export function openEnrollDialog() {
  EnrollContext.open();
}
